import type { Snapshot } from '@/api/v4/snapshot-funnel.api';
import { isDealStage, ListingStageName } from '@/features/listing-stage/types';

export const filterOutStatusesNotShownInChart = (data: Snapshot) => {
  return data.filter(
    status =>
      status.name !== ListingStageName.notRelevant && !isDealStage(status.name),
  );
};
